<template>
  <div>
    <b-table v-if="Array.isArray(stats)" :fields="fields" :items="stats">
      <template #cell(WINNINGS)="row">
        <template v-if="row.item.WINNINGS == '0.00'">

        </template>
        <template v-else>
          {{ row.item.CURRENCY_SIGN }} {{ row.item.WINNINGS }}
        </template>
      </template>
      <template #cell(POSITION)="row">
        {{ row.item.POSITION }} <span v-if="row.item.POSITION == '1'"> <b-img class='trophy' :src="config.VUE_APP_WP_DIGITAL_OCEAN+'2019/07/TROPHY.png'"></b-img></span>
      </template>
    </b-table>
    <table v-else>
      <thead>
        <tr>
          <th class="title">
            Date
          </th>
          <th class="title">
            Name
          </th>
          <th class="title">
            Position
          </th>
          <th class="title">
            Score
          </th>
          <th class="title">
            VSPAR
          </th>
          <th class="title">
            Round
          </th>
          <th class="title">
            Winnings
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="cell">
            {{ stats.DATE }}
          </td>
          <td class="cell">
            {{ stats.NAME }}
          </td>
          <td class="cell">
            {{ stats.POSITION }}
          </td>
          <td class="cell">
            {{ stats.SCORE }}
          </td>
          <td class="cell">
            {{ stats.VSPAR }}
          </td>
          <td class="cell">
            {{ stats.ROUNDS }}
          </td>
          <td class="cell winnings">{{ stats.CURRENCY_SIGN }} {{ stats.WINNINGS }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "playerCareerHigh",
  props: ["stats", 'config'],
  data() {
    return {
      fields: [
        { key: "DATE", label: "Date", class: 'center' },
        { key: "NAME", label: "Name" },
        { key: "POSITION", label: "Pos" },
        { key: "SCORE", label: "Score" ,class: "hideclass"},
        { key: "VSPAR", label: "VSPAR" ,class: "hideclass"},
        { key: "ROUNDS", label: "Round", class: "hideclass" },
        { key: "WINNINGS", label: "Winnings", class:"winningColors" }
      ]
    };
  }
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  ::v-deep th.hideclass {
    display: none;
  }
    ::v-deep td.hideclass {
    display: none;
  }
}
::v-deep th.center {
    text-align: center !important;
}
::v-deep td.center {
    text-align: center !important;
}
::v-deep td.winningColors {
  color: #003C52!important;
}
::v-deep table>thead>tr>th{
  background-color: #003C52;
  padding: 16px;
  text-align: left;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  padding-left: 0;
  /* border-right: 1px solid black; */
}

::v-deep table>tbody>tr>td{
  text-align: left;
  padding: 5px;
  padding-top: 12px;
  padding-bottom: 12px;
  background-color: #f9f9f9!important;
  line-height: 22px;
  min-height: 38px;
  color: black;
  font-weight: 700;
  border-top: 1px solid #d9d9d8;
  font-size: 14px;
  white-space: nowrap;
  width: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.trophy{
  width: 15px;
}
</style>
